export const styles = theme => ({
  btnRoot: {
    // color: '#263238',
    color: "inherit",
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingLeft: "16px",
    paddingRight: "16px",
    // fontSize: '14px',
    fontSize: "0.8rem",
    justifyContent: "left",
    // width: '100%',
    fontWeight: 500,
    lineHeight: 1.75,
    borderRadius: "4px",
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.87)",
    backgroundColor: "#ffffff"
  },
  calendarIcon: {
    marginRight: theme.spacing(1)
  }
});
